import styled from 'styled-components'

export const FormWrapper = styled.div.withConfig({
  shouldForwardProp: prop => !['orientation', 'isInModal'].includes(prop as string),
})<{ orientation?: string; isInModal?: boolean }>`
  display: grid;
  gap: 10px;
  margin-bottom: 24px;

  ${({ orientation, isInModal }) => {
    if (isInModal) {
      return 'grid-template-columns: 1fr; max-width: 100%;'
    }
    return orientation == 'horizontal'
      ? 'grid-template-columns: repeat(auto-fill, max(400px));'
      : ''
  }}
  max-width: ${({ orientation, isInModal }) => {
    if (isInModal) return '100%'
    return orientation == 'horizontal' ? '100%' : '500px'
  }};
  align-items: start;
  justify-content: space-between;
  /*
  &>div {
    width: fit-content;
  }
  */

  .ant-select.ant-select-disabled {
    background-color: #f5f5f5;
  }

  .ant-picker input,
  .ant-picker-suffix,
  .ant-picker-clear {
    color: inherit;
  }

  .ant-picker {
    input,
    .ant-picker-suffix,
    .ant-picker-clear {
      color: inherit;
    }
    .ant-picker-clear {
      background: inherit;
    }

    .ant-picker-input {
      transition: opacity 0.3s, color 0.3s;
    }

    .ant-picker-input:hover .ant-picker-suffix {
      opacity: 0;
    }
  }

  @media (max-width: 1200px) {
    gap: 10px;
  }

  @media (max-width: 768px) {
    display: block;
  }
`

export const FormItem = styled.div<{ $mergedFields?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $mergedFields }) => ($mergedFields ? '10px' : '16px')};
  width: 100%;
  align-items: stretch;

  .ant-form-item .ant-form-item-label > label {
    color: #5f5f5f;
    font-weight: bold;
  }

  .ant-form-item {
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 12px;
    padding-bottom: 12px;
    width: 100%;

    .ant-row {
      display: block;
    }

    .ant-form-item-control-input {
      min-height: unset;
    }

    .ant-picker {
      width: 100%;
    }
  }

  ${({ $mergedFields }) =>
    $mergedFields &&
    `
    .ant-form-item:not(:last-child) {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
    .ant-form-item:last-child {
      margin-bottom: 12px;
      padding-bottom: 12px;
    }
  `}
`

export const GroupBody = styled.div``
